












/**
 * This abomination was implemented to satisify a requirement of the existing tablet.
 */
import { Component, Prop } from "vue-property-decorator";

import { handlebars } from "@/utils";
import { i18n } from "@/i18n";

import WCheckbox from "./Checkbox.vue";

@Component
export default class WPhoneCheckbox extends WCheckbox {
  @Prop({ type: String })
  landlineLabel?: string;

  @Prop({ type: String })
  mobileLabel?: string;

  get phoneOptIn() {
    return !!this.getVariable("fields.phone_opt_in");
  }

  get smsOptIn() {
    return !!this.getVariable("fields.sms_opt_in");
  }

  get phoneIsOptedIn() {
    return !!this.getVariable("fields.phone_is_opted_in");
  }

  get smsIsOptedIn() {
    return !!this.getVariable("fields.sms_is_opted_in");
  }

  get isMobile() {
    const type = this.getVariable("fields.phone_type");
    return type === "MOBILE";
  }

  get computedDisabled() {
    return this.isMobile
      ? this.phoneIsOptedIn && this.smsIsOptedIn
      : this.phoneIsOptedIn;
  }

  get computedText() {
    const context = this.$store.getters["context/getContext"];
    return this.isMobile
      ? this.mobileLabel
        ? handlebars(i18n.t(this.mobileLabel) as any, context)
        : this.$t("message.mobile").toString()
      : this.landlineLabel
        ? handlebars(i18n.t(this.landlineLabel) as any, context)
        : this.$t("message.phone").toString();
  }

  get fieldValue() {
    const phoneOptIn = this.phoneOptIn || this.phoneIsOptedIn;
    const smsOptIn = this.smsOptIn || this.smsIsOptedIn;

    return this.isMobile ? phoneOptIn && smsOptIn : phoneOptIn;
  }

  set fieldValue(value: any) {
    this.setPhoneOptin(value).setSMSOptin(value);
    this.state = this.validate(value);
  }

  setPhoneOptin(value: boolean) {
    this.setVariable({
      path: "fields.phone_opt_in",
      value: value || this.phoneIsOptedIn
    });
    return this;
  }

  setSMSOptin(value: boolean) {
    this.setVariable({
      path: "fields.sms_opt_in",
      value: (value || this.smsIsOptedIn) && this.isMobile
    });
    return this;
  }

  changeHandler() {
    this.$nextTick(() => {
      const event = this.isChecked ? "checked" : "unchecked";
      if (event === "checked" && !this.state) {
        return;
      }
      this.broadcastEvents(event);
    });
  }
}
